export default __webpack_public_path__ + "static/media/icon-em-delivered.1ffce563.svg";